import React, {useState} from "react";
import {Button, Col, Layout, Row, Switch} from "antd";
import ColumnsModal from "../components/ColumnsModal";
import classes from './Layer.module.css'
import FontsModal from "../components/FontsModal";
import LocationModal from "../components/LocationsModal";
import {useLocation, useNavigate} from 'react-router-dom';
import {useDispatch, useSelector} from "react-redux";
import {TOGGLE_INCLUDE_UNRECOGNIZED_CHIPS, SET_IS_LOGGED_IN, SET_USER_NAME} from "../store";

const { Header, Content } = Layout

interface IProps {
    children: any
}

interface IState {
    displayReducer: {
        Comp: number | null
        IncludeUnrecognizedChips: boolean
    },
    authReducer: {
        IsLoggedIn: boolean
    }
}

export default function Layer({children}: IProps) {
    const [columnsModalVisible, setColumnsModalVisible] = useState<boolean>(false)
    const [fontsModalVisible, setFontsModalVisible] = useState<boolean>(false)
    const [locationModalVisible, setLocationModalVisible] = useState<boolean>(false)
    const location = useLocation()
    const pageName = location.pathname.split('/').pop()
    const navigate = useNavigate()
    const isLoggedIn = useSelector((state: IState) => state.authReducer.IsLoggedIn)
    const comp = useSelector((state: IState) => state.displayReducer.Comp)
    const includeUnrecognizedChips = useSelector((state: IState) => state.displayReducer.IncludeUnrecognizedChips);
    const dispatch = useDispatch()

    function logout() {
        localStorage.removeItem('caruzToken');
        localStorage.removeItem('caruzUsername');
        dispatch({
            type: SET_USER_NAME,
            payload: {
                username: null
            }
        })

        dispatch({
            type: SET_IS_LOGGED_IN,
            payload: {
                isLoggedIn: false
            }
        })
    }

    return (
        <>
            <Layout>
                <Header className={classes.header}>
                    <Row>
                        <Col xs={24} sm={24} md={8} xl={8} xxl={8}  style={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            gap: '8px',
                            flexWrap: 'nowrap',
                            marginTop: '16px',
                        }}>
                            {isLoggedIn && comp &&
                                <>
                                    <Button
                                        onClick={() => setLocationModalVisible(true)}
                                    >
                                        Locations
                                    </Button>

                                    <Button
                                        onClick={() => setColumnsModalVisible(true)}
                                    >
                                        Columns
                                    </Button>


                                    <Button
                                        onClick={() => setFontsModalVisible(true)}
                                    >
                                        Fonts
                                    </Button>
                                </>
                            }
                        </Col>
                        <Col xs={0} sm={0} md={0} lg={8} xl={8} xxl={8} style={{textAlign: 'center'}}>
                            {pageName?.toLowerCase() === 'events' && <h1>רשימת ארועים</h1>}
                            {pageName?.toLowerCase() === 'display' && <h1>{comp}</h1>}
                            {pageName?.toLowerCase() === 'login' && <h1>LOGIN</h1>}
                        </Col>
                        <Col xs={0} sm={0} md={12} lg={8} xl={8} xxl={8}>
                            {isLoggedIn &&
                                <>
                                    <Button
                                        style={{
                                            marginRight: '8px',
                                            float: "right",
                                            marginTop: '16px',
                                        }}
                                        onClick={logout}
                                    >Logout
                                    </Button>

                                    <Button
                                        style={{
                                            marginRight: '8px',
                                            float: "right",
                                            marginTop: '16px',
                                        }}
                                        onClick={() => navigate('/events')}
                                    >Events
                                    </Button>
                                    <div style={{float: "right", marginRight: '40px', color: "white", fontSize: '18px'}}>
                                        <label>Include Unrecognized Chips&nbsp;&nbsp;&nbsp;</label>
                                        <Switch
                                            checked={includeUnrecognizedChips}
                                            onChange={() => dispatch({
                                                type: TOGGLE_INCLUDE_UNRECOGNIZED_CHIPS,
                                            })}
                                        />
                                    </div>
                                </>
                            }
                        </Col>
                    </Row>
                </Header>
                <Content>
                    {children}
                </Content>
            </Layout>
            {columnsModalVisible &&
                <ColumnsModal
                    Visible={columnsModalVisible}
                    CloseModal={() => setColumnsModalVisible(false)}
                />
            }
            {fontsModalVisible &&
                <FontsModal
                    Visible={fontsModalVisible}
                    CloseModal={() => setFontsModalVisible(false)}
                />
            }
            {locationModalVisible && comp &&
                <LocationModal
                    Visible={locationModalVisible}
                    CloseModal={() => setLocationModalVisible(false)}
                    Comp={comp}
                />
            }
        </>
    )
}